<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation #mainNavigation
                          class="dark bg-blue-950 print:hidden text-white"
                          [mode]="isScreenSmall ? 'over' : 'side'"
                          [name]="'mainNavigation'"
                          [opened]="navigationOpened"
                          (openedChanged)="onNavigationOpenedChanged($event)">
    <!-- Sticky Navigation header hook -->
    <ng-container fuseVerticalNavigationHeader>
        <div class="flex h-16 items-center px-4"
             [ngClass]="{'justify-between': navigationOpened, 'justify-center': !navigationOpened}">
            @if (navigationOpened) {
            <div class="flex items-center min-w-0 gap-3">
                <img class="h-8 w-auto flex-shrink-0"
                     src="images/logo/logo.svg"
                     alt="GAC Logo" />
                <div class="flex flex-col min-w-0">
                    <span class="text-white text-sm font-semibold tracking-tight truncate leading-tight">Marine Logistics</span>
                    <span class="text-white/60 text-[9px] truncate leading-tight">Delivering your strategy</span>
                </div>
            </div>
            }

            @if (!navigationOpened) {
            <div class="flex items-center justify-center p-1">
                <img class="h-7 w-auto"
                     src="images/logo/logo.svg"
                     alt="GAC Logo" />
            </div>
            }
        </div>

        <div class="flex items-center px-4 pt-2 pb-2"
             [ngClass]="{'justify-between': navigationOpened, 'justify-center': !navigationOpened}">
            @if (navigationOpened) {
            <span class="text-[10px] font-semibold text-white/50 uppercase tracking-widest">MENU</span>
            <button mat-icon-button
                    class="!w-6 !h-6 !min-w-6 text-white/60 hover:text-white hover:bg-white/10 rounded-md flex items-center justify-center transition-colors cursor-pointer"
                    (click)="toggleNavigation('mainNavigation')"
                    matTooltip="Collapse menu">
                <mat-icon class="icon-size-3.5 text-white/60"
                          [svgIcon]="'heroicons_solid:chevron-left'"></mat-icon>
            </button>
            } @else {
            <button mat-icon-button
                    class="!w-7 !h-7 !min-w-7 text-white/70 hover:text-white hover:bg-white/10 rounded-md flex items-center justify-center transition-colors cursor-pointer"
                    (click)="toggleNavigation('mainNavigation')"
                    matTooltip="Expand menu">
                <mat-icon class="icon-size-4 text-white/70"
                          [svgIcon]="'heroicons_solid:chevron-right'"></mat-icon>
            </button>
            }
        </div>
    </ng-container>

</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Header -->
    <div class="bg-card relative z-49 flex h-12 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-6 print:hidden">
        <!-- Navigation toggle button -->
        <button mat-icon-button
                (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        <!-- Components -->
        <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <user></user>
        </div>
    </div>

    <!-- Content -->
    <router-outlet></router-outlet>

    <!-- Footer -->
    <div class="bg-card relative z-49 flex h-8 w-full flex-0 items-center justify-start border-t px-4 dark:bg-transparent  print:hidden">
        <span class="text-secondary font-medium">Marlog 2.0.0</span>
    </div>
</div>